<template>
  <div>
    <loading v-if="loading" />
    <div v-if="isAuthenticated">
      <h1>Willkommen in der Stundenschreibung</h1>
      <router-link to="/hours" class="btn btn-info">Stunden eintragen</router-link><br />
      <br />
      <router-link to="/users/userHoursDateRange" class="btn btn-info">Stundenübersicht</router-link><br />
      <br />
      <router-link to="/users/users" class="btn btn-info">Nutzerübersicht</router-link><br />
      <br />
      <router-link to="/projects" class="btn btn-info">Projektübersicht</router-link><br />
      <br />
      <router-link to="/leaves" class="btn btn-info">Urlaubsübersicht</router-link><br />
      <br />
      <router-link to="/illnesses" class="btn btn-info">Krankheitsübersicht</router-link>
      <br />
      <!-- Insert  bezahlte Überstunden Form-->
      <div v-if="adminAccess">
        <PaidOvertime />
      </div>

    </div>
    <div v-if="!isAuthenticated && authStatus !== 'loading'">
      <h1>Netzlab Hourtracker</h1>
      <p>
        Anmelden, um Zugriff auf die Stundenschreibung zu bekommen.
      </p>
      <login />
    </div>
  </div>
</template>

<style>
  .home {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
</style>

<script>
  import { mapGetters, mapState } from "vuex";
  import Login from "components/login";
  import Hours from "../hours/hours";
  import Users from "../users/users";
  import PaidOvertime from "components/admin/paidovertime"
  import axios from "axios";

  export default {
    components: {
      Login,
      Hours,
      Users,
      PaidOvertime
    },
    name: "home",
    computed: {
      ...mapGetters(["isAuthenticated", "authStatus", "getProfile"]),
      ...mapState({
        email: state => state.user.profile.email,
        adminAccess: state => state.user.profile.adminAccess,
      }),
      loading: function () {
        return this.authStatus === "loading" && !this.isAuthenticated;
      }
    }
  };
</script>
